<template>
    <div class="layout-header">
        <div class="header-title">
            <div class="left">
                <img src="@/images/1-02.png" alt="医院logo" />
                <span>互联网医院</span>
            </div>
            <img src="@/images/1-01.png" alt="医院标识" />
        </div>
        <div class="header-right">
            <div class="left">
                <img src="@/images/1-03.png" alt="当前位置图标" />
                <span>{{ currentName }}</span>
            </div>

            <div class="right">
                <!-- 用户信息部分 -->
                <div class="userBox">
                    <div class="avatar">
                        <img :src="userName.avatar" :alt="userName.name" />
                        <div class="lineStatus online">
                            <span>在线</span>
                        </div>
                    </div>
                    <div class="nameBox">
                        <div class="name">{{ userName.name }}</div>
                        <div class="name2">{{ userName.department_title }}</div>
                    </div>
                    <div class="imageBpx">
                        <div @click="handleClick(1)" title="修改密码">
                            <img src="@/images/1-17.png" alt="修改密码" />
                        </div>
                        <div @click="handleClick(2)" title="消息通知" class="notification-btn">
                            <img src="@/images/1-18.png" alt="消息通知" />
                            <span v-if="unread_count > 0" class="notification-badge">
                                {{ formatUnreadCount }}
                            </span>
                        </div>
                        <div @click="logout" title="退出登录">
                            <img src="@/images/logout.png" alt="退出登录" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 全局消息提示 -->
        <div v-if="showGlobalAlert" class="global-alert" :class="alertType">
            <div class="alert-content">
                <span>{{ globalAlertMessage }}</span>
            </div>
            <span @click="closeGlobalAlert" class="alert-close">×</span>
        </div>
    </div>
</template>

<script>
// 引入WebSocket相关的mixin
import notificationMixin from '@/mixins/notificationMixin';

export default {
    name: 'HeaderVue',
    mixins: [notificationMixin],
    data() {
        return {
            unread_count: 0,
            showGlobalAlert: false,
            globalAlertMessage: '',
            alertType: 'info',

            // WebSocket相关
            ws: null,
            isManualClose: false,
            reconnectTimer: null,
            reconnectCount: 0,
            maxReconnectCount: 10, // 增加最大重连次数

            // 心跳机制相关 - 根据服务器要求设置
            heartbeatTimer: null,
            heartbeatInterval: 25000, // 25秒发送一次心跳，略小于30秒的常见超时时间
            heartbeatTimeoutTimer: null,
            heartbeatTimeout: 10000, // 10秒心跳响应超时
            lastHeartbeatTime: null, // 最后发送心跳的时间
            heartbeatMissedCount: 0, // 心跳丢失次数
            maxHeartbeatMissed: 3, // 最大允许丢失心跳次数

            // 页面可见性状态
            isPageVisible: true,
        };
    },
    computed: {
        currentName() {
            return this.$store.state.publicStore.name || '';
        },
        userName() {
            return this.$store.state.publicStore.userName || {};
        },
        formatUnreadCount() {
            if (this.unread_count > 99) return '99+';
            return this.unread_count;
        },
        // WebSocket连接状态
        wsStatus() {
            if (!this.ws) return '未连接';
            switch (this.ws.readyState) {
                case WebSocket.CONNECTING:
                    return '连接中';
                case WebSocket.OPEN:
                    return '已连接';
                case WebSocket.CLOSING:
                    return '关闭中';
                case WebSocket.CLOSED:
                    return '已关闭';
                default:
                    return '未知';
            }
        },
    },
    created() {
        this.initWebSocket();
        this.setupEventListeners();
    },
    beforeDestroy() {
        this.cleanup();
    },
    methods: {
        // 初始化WebSocket连接
        initWebSocket() {
            // 如果正在重连中，先清除重连定时器
            if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
                this.reconnectTimer = null;
            }

            // 如果已连接，不再重复连接
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                console.log('WebSocket已连接，跳过初始化');
                return;
            }

            // 清理旧连接
            this.cleanupWebSocket();

            try {
                const userType = localStorage.getItem('userType');
                const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
                const action = userType == 1 ? '2' : '3';
                const actionId = userInfo.id;

                if (!actionId) {
                    console.warn('用户ID不存在，延迟WebSocket连接');
                    // 延迟1秒再尝试连接
                    setTimeout(() => {
                        this.initWebSocket();
                    }, 1000);
                    return;
                }

                const url = `wss://hlwyy.sgdoctor.cn:8090?info=getSysCount&action_id=${actionId}&action=${action}`;
                console.log('正在连接WebSocket:', url);

                this.ws = new WebSocket(url);

                // 设置连接超时
                const connectTimeout = setTimeout(() => {
                    if (this.ws && this.ws.readyState === WebSocket.CONNECTING) {
                        console.warn('WebSocket连接超时');
                        this.ws.close();
                        this.handleReconnect();
                    }
                }, 10000);

                this.ws.onopen = () => {
                    clearTimeout(connectTimeout);
                    console.log('WebSocket连接成功');
                    this.onConnectSuccess();
                };

                this.ws.onmessage = (event) => {
                    this.handleMessage(event);
                };

                this.ws.onerror = (error) => {
                    clearTimeout(connectTimeout);
                    console.error('WebSocket连接错误:', error);
                    this.onConnectError();
                };

                this.ws.onclose = (event) => {
                    clearTimeout(connectTimeout);
                    console.log('WebSocket连接关闭:', event.code, event.reason);
                    this.onConnectClose(event);
                };
            } catch (error) {
                console.error('WebSocket初始化失败:', error);
                this.handleReconnect();
            }
        },

        // 连接成功处理
        onConnectSuccess() {
            console.log('WebSocket连接状态:', this.wsStatus);
            this.reconnectCount = 0; // 重置重连次数
            this.heartbeatMissedCount = 0; // 重置心跳丢失计数
            this.startHeartbeat(); // 开始心跳
            this.showGlobalMessage('系统连接成功', 'success');

            // 连接成功后请求未读消息数量
            setTimeout(() => {
                this.requestUnreadCount();
            }, 1000);
        },

        // 连接错误处理
        onConnectError() {
            console.error('WebSocket连接错误，状态:', this.wsStatus);
            // this.showGlobalMessage('连接异常，请检查网络', 'error');
            this.handleReconnect();
        },

        // 连接关闭处理
        onConnectClose(event) {
            console.log(`WebSocket连接关闭，代码: ${event.code}, 原因: ${event.reason || '无'}`);
            this.stopHeartbeat();

            // 如果不是手动关闭，且页面可见，则尝试重连
            if (!this.isManualClose && this.isPageVisible) {
                this.handleReconnect();
            }
        },

        // 处理消息
        handleMessage(event) {
            try {
                const data = JSON.parse(event.data);

                // 处理心跳响应 - 根据服务器实际返回的字段判断
                if (data.type === 'pong' || data.type === 'ping_response' || data.msg === 'pong') {
                    this.handleHeartbeatResponse();
                    return;
                }

                // 处理未读消息数量更新
                if (data.type === 'unread_count_update') {
                    console.log('收到WebSocket消息:', data);

                    const newCount = data.unread_count || 0;
                    if (newCount !== this.unread_count) {
                        this.unread_count = newCount;
                        console.log('更新未读消息数量:', this.unread_count);

                        // 如果有新消息，显示通知
                        if (newCount > 0) {
                            this.showNewMessageNotification();
                        }
                    }
                }

                // 处理其他类型的消息（可根据需要扩展）
                if (data.type && data.type !== 'unread_count_update') {
                    console.log('收到其他类型消息:', data.type);
                }
            } catch (error) {
                console.error('解析消息错误:', error, '原始数据:', event.data);
            }
        },

        // 显示新消息通知
        showNewMessageNotification() {
            // 可以在这里添加声音提示或桌面通知
            console.log('您有新的消息');

            // 如果浏览器支持通知API且用户已授权
            if ('Notification' in window && Notification.permission === 'granted') {
                new Notification('新消息通知', {
                    body: `您有${this.unread_count}条未读消息`,
                    icon: '/favicon.ico',
                });
            }
        },

        // 心跳机制相关方法
        startHeartbeat() {
            this.stopHeartbeat(); // 先停止之前的定时器

            // console.log('开始心跳监测，间隔:', this.heartbeatInterval, 'ms');

            // 立即发送第一次心跳
            this.sendHeartbeat();

            // 定时发送心跳
            this.heartbeatTimer = setInterval(() => {
                this.sendHeartbeat();
            }, this.heartbeatInterval);
        },

        stopHeartbeat() {
            if (this.heartbeatTimer) {
                clearInterval(this.heartbeatTimer);
                this.heartbeatTimer = null;
                // console.log('停止心跳监测');
            }

            if (this.heartbeatTimeoutTimer) {
                clearTimeout(this.heartbeatTimeoutTimer);
                this.heartbeatTimeoutTimer = null;
            }
        },

        // 发送心跳包
        sendHeartbeat() {
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                try {
                    const heartbeatMsg = JSON.stringify({
                        type: 'ping',
                        timestamp: Date.now(),
                    });
                    this.ws.send(heartbeatMsg);
                    this.lastHeartbeatTime = Date.now();
                    // console.log('发送心跳:', heartbeatMsg);

                    // 设置心跳响应超时检测
                    this.heartbeatTimeoutTimer = setTimeout(() => {
                        this.checkHeartbeatResponse();
                    }, this.heartbeatTimeout);
                } catch (error) {
                    console.error('发送心跳失败:', error);
                    this.heartbeatMissedCount++;

                    // 如果连续多次发送失败，尝试重连
                    if (this.heartbeatMissedCount >= this.maxHeartbeatMissed) {
                        console.warn('心跳发送连续失败，重新连接');
                        this.reconnect();
                    }
                }
            } else {
                console.warn('WebSocket未连接，无法发送心跳');
                this.heartbeatMissedCount++;

                // 如果WebSocket未连接，尝试重连
                if (this.heartbeatMissedCount >= 2) {
                    console.warn('WebSocket未连接，尝试重连');
                    this.reconnect();
                }
            }
        },

        // 处理心跳响应
        handleHeartbeatResponse() {
            // console.log('收到心跳响应');

            // 清除超时检测
            if (this.heartbeatTimeoutTimer) {
                clearTimeout(this.heartbeatTimeoutTimer);
                this.heartbeatTimeoutTimer = null;
            }

            // 重置心跳丢失计数
            this.heartbeatMissedCount = 0;

            // 计算心跳往返时间
            if (this.lastHeartbeatTime) {
                const rtt = Date.now() - this.lastHeartbeatTime;
                // console.log(`心跳往返时间: ${rtt}ms`);

                // 根据往返时间动态调整心跳间隔
                this.adjustHeartbeatInterval(rtt);
            }
        },

        // 根据网络状况动态调整心跳间隔
        adjustHeartbeatInterval(rtt) {
            // 如果延迟较大，适当增加心跳间隔
            if (rtt > 5000) {
                this.heartbeatInterval = 30000; // 延迟大，使用30秒间隔
            } else if (rtt > 2000) {
                this.heartbeatInterval = 25000; // 中等延迟，使用25秒间隔
            } else {
                this.heartbeatInterval = 20000; // 延迟小，使用20秒间隔
            }

            // 重新启动心跳定时器
            if (this.heartbeatTimer) {
                this.stopHeartbeat();
                this.startHeartbeat();
            }
        },

        // 检查心跳响应
        checkHeartbeatResponse() {
            this.heartbeatMissedCount++;
            console.warn(`心跳响应超时，丢失次数: ${this.heartbeatMissedCount}`);

            // 如果连续丢失心跳达到最大次数，重新连接
            if (this.heartbeatMissedCount >= this.maxHeartbeatMissed) {
                console.error('心跳连续丢失，重新连接');
                this.reconnect();
            } else {
                // 未达到最大次数，继续等待
                console.log('继续等待心跳响应');
            }
        },

        // 重连机制
        handleReconnect() {
            // 如果已达到最大重连次数
            if (this.reconnectCount >= this.maxReconnectCount) {
                console.error(`已达到最大重连次数(${this.maxReconnectCount})，停止重连`);
                // this.showGlobalMessage('连接已断开，请刷新页面重试', 'warning');
                return;
            }

            this.reconnectCount++;

            // 使用指数退避策略计算延迟时间
            const baseDelay = 1000; // 1秒基础延迟
            const maxDelay = 30000; // 最大延迟30秒
            const delay = Math.min(baseDelay * Math.pow(1.5, this.reconnectCount - 1), maxDelay);

            console.log(`第${this.reconnectCount}次重连，${delay}ms后重连`);

            this.reconnectTimer = setTimeout(() => {
                console.log('开始重连...');
                this.initWebSocket();
            }, delay);
        },

        // 重新连接
        reconnect() {
            console.log('触发重新连接');
            if (this.ws) {
                this.ws.close();
            }
            this.handleReconnect();
        },

        // 请求未读消息数量
        requestUnreadCount() {
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                try {
                    const msg = JSON.stringify({
                        type: 'get_unread_count',
                        action: 'request',
                        timestamp: Date.now(),
                    });
                    this.ws.send(msg);
                    console.log('请求未读消息数量:', msg);
                } catch (error) {
                    console.error('请求未读消息数量失败:', error);
                }
            } else {
                console.warn('WebSocket未连接，无法请求未读消息数量');
            }
        },

        // 手动刷新消息数量
        refreshMessageCount() {
            this.requestUnreadCount();
            // this.showGlobalMessage('正在刷新消息...', 'info');
        },

        // 设置事件监听器
        setupEventListeners() {
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
            window.addEventListener('focus', this.handlePageFocus);
            window.addEventListener('beforeunload', this.handleBeforeUnload);

            // 监听网络状态变化
            window.addEventListener('online', this.handleNetworkOnline);
            window.addEventListener('offline', this.handleNetworkOffline);
        },

        // 清理资源
        cleanup() {
            this.isManualClose = true;

            // 移除事件监听
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
            window.removeEventListener('focus', this.handlePageFocus);
            window.removeEventListener('beforeunload', this.handleBeforeUnload);
            window.removeEventListener('online', this.handleNetworkOnline);
            window.removeEventListener('offline', this.handleNetworkOffline);

            // 清理定时器
            if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
                this.reconnectTimer = null;
            }

            // 清理WebSocket
            this.cleanupWebSocket();
        },

        cleanupWebSocket() {
            this.stopHeartbeat();

            if (this.ws) {
                // 移除所有事件监听器
                this.ws.onopen = null;
                this.ws.onmessage = null;
                this.ws.onerror = null;
                this.ws.onclose = null;

                // 关闭连接
                if (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING) {
                    this.ws.close(1000, '正常关闭');
                }

                this.ws = null;
            }
        },

        // 页面可见性变化处理
        handleVisibilityChange() {
            this.isPageVisible = !document.hidden;
            console.log('页面可见性变化:', this.isPageVisible ? '可见' : '隐藏');

            if (this.isPageVisible) {
                // 页面恢复可见时，检查连接状态
                setTimeout(() => {
                    this.checkConnectionStatus();
                }, 500);
            } else {
                // 页面隐藏时，可以适当降低心跳频率或暂停心跳
                // 这里我们选择保持心跳，但可以记录状态
                console.log('页面隐藏，保持现有连接');
            }
        },

        // 页面获得焦点
        handlePageFocus() {
            console.log('页面获得焦点，检查连接状态');
            setTimeout(() => {
                this.checkConnectionStatus();
            }, 300);
        },

        // 网络恢复在线
        handleNetworkOnline() {
            console.log('网络恢复在线');
            // this.showGlobalMessage('网络已恢复', 'success');

            // 检查WebSocket连接
            setTimeout(() => {
                this.checkConnectionStatus();
            }, 1000);
        },

        // 网络离线
        handleNetworkOffline() {
            console.log('网络已离线');
            // this.showGlobalMessage('网络连接已断开', 'warning');
        },

        // 检查连接状态
        checkConnectionStatus() {
            if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
                console.log('连接已断开，尝试重连');
                this.initWebSocket();
            } else {
                console.log('连接正常，状态:', this.wsStatus);
                // 连接正常，发送一次心跳测试
                this.sendHeartbeat();
                // 请求最新未读消息
                setTimeout(() => {
                    this.requestUnreadCount();
                }, 500);
            }
        },

        // 页面卸载前处理
        handleBeforeUnload() {
            this.isManualClose = true;
            this.cleanupWebSocket();
        },

        // 显示全局消息提示
        showGlobalMessage(message, type = 'info') {
            this.globalAlertMessage = message;
            this.alertType = type;
            this.showGlobalAlert = true;

            // 根据类型设置不同的自动关闭时间
            let autoCloseTime = 3000;
            if (type === 'error') autoCloseTime = 5000;
            if (type === 'warning') autoCloseTime = 4000;

            // 清除之前的定时器
            if (this.alertTimer) {
                clearTimeout(this.alertTimer);
            }

            // 设置新的定时器
            this.alertTimer = setTimeout(() => {
                this.closeGlobalAlert();
            }, autoCloseTime);
        },

        closeGlobalAlert() {
            this.showGlobalAlert = false;
            if (this.alertTimer) {
                clearTimeout(this.alertTimer);
                this.alertTimer = null;
            }
        },

        // 原有的业务方法
        handleCommand(e) {
            if (e == 'logout') {
                this.logout();
            } else if (e == 'user') {
                this.$router.push('/user/schedule');
                this.$store.dispatch('publicStore/setName', '我的排班');
            }
        },

        logout() {
            this.$confirm('此操作将退出登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    this.isManualClose = true;
                    this.cleanupWebSocket();

                    // 清除本地存储
                    localStorage.removeItem('userType');
                    localStorage.removeItem('doctor_id');
                    localStorage.removeItem('visitedViews');
                    localStorage.removeItem('vuex');
                    localStorage.clear();

                    this.$router.replace('/login');
                    this.$store.dispatch('publicStore/setName', '');
                })
                .catch(() => {});
        },

        handleClick(type) {
            switch (type) {
                case 1:
                    this.handleMenuItemClick('修改密码', '/settings/change-password');
                    break;
                case 2:
                    this.handleMenuItemClick('消息通知', '/settings/notifications');
                    // 点击消息图标时，刷新消息数量
                    this.refreshMessageCount();
                    break;
                default:
                    break;
            }
        },

        handleMenuItemClick(name, url) {
            if (this.$route.path !== url) {
                this.$store.dispatch('publicStore/setName', '');
                this.$store.dispatch('publicStore/setName', name);
                this.$router.push(url).catch((err) => {
                    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') {
                        console.error('菜单跳转失败:', err);
                    }
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.layout-header {
    width: 100%;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
    height: 90px !important;
    padding: 0 20px;
    box-sizing: border-box;
    position: relative;

    .header-title {
        display: flex;
        align-items: center;
        width: 200px;
        height: 100%;
        justify-content: space-between;
        .left {
            display: flex;
            align-items: center;
            font-size: 26px;
            color: #7b2820;
            font-weight: bold;
            img {
                width: 43px;
                margin-right: 10px;
            }
        }
    }

    .header-right {
        flex: 1;
        padding-left: 10px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            font-weight: bold;
            display: flex;
            align-items: center;
            font-size: 24px;
            color: #333333;
            img {
                width: 28px;
                margin-right: 10px;
            }
        }

        .right {
            display: flex;
            align-items: center;
            position: relative;

            .userBox {
                display: flex;
                align-items: center;

                .avatar {
                    width: 66px;
                    height: 66px;
                    position: relative;
                    margin-right: 20px;

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        object-fit: cover;
                    }

                    .lineStatus {
                        position: absolute;
                        bottom: 0;
                        width: 50px;
                        height: 20px;
                        background: #ccc;
                        border-radius: 6px;
                        color: #fff;
                        text-align: center;
                        line-height: 20px;
                        left: 50%;
                        margin-left: -25px;
                        font-size: 12px;

                        &.online {
                            background: #7b2820;
                        }
                    }
                }

                .nameBox {
                    .name {
                        font-size: 20px;
                        color: #333333;
                        font-weight: bold;
                        margin-bottom: 5px;
                        margin-top: 5px;
                    }
                    .name2 {
                        font-size: 14px;
                        color: #999999;
                    }
                }

                .imageBpx {
                    display: flex;
                    align-items: center;
                    margin-left: 30px;

                    div {
                        position: relative;
                        cursor: pointer;
                        transition: all 0.3s ease;

                        &:hover {
                            opacity: 0.8;
                            transform: translateY(-2px);
                        }

                        &:active {
                            transform: translateY(0);
                        }

                        img {
                            width: 50px;
                            height: 50px;
                            margin-left: 20px;
                        }

                        &.notification-btn {
                            position: relative;
                            animation: pulse 2s infinite;
                        }

                        .notification-badge {
                            position: absolute;
                            top: -2px;
                            right: -2px;
                            background-color: #ff4d4f;
                            color: white;
                            font-size: 12px;
                            font-weight: bold;
                            min-width: 18px;
                            height: 18px;
                            border-radius: 9px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 0 4px;
                            border: 2px solid white;
                            z-index: 1;
                            animation: badgePulse 1.5s infinite;
                        }
                    }
                }
            }
        }
    }

    /* 全局消息提示样式 */
    .global-alert {
        position: fixed;
        top: 100px;
        right: 20px;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        padding: 12px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-width: 300px;
        max-width: 500px;
        z-index: 2000;
        animation: slideIn 0.3s ease-out;

        &.success {
            border-left: 4px solid #52c41a;
            background: linear-gradient(90deg, #f6ffed 0%, #ffffff 100%);
        }

        &.info {
            border-left: 4px solid #1890ff;
            background: linear-gradient(90deg, #e6f7ff 0%, #ffffff 100%);
        }

        &.warning {
            border-left: 4px solid #faad14;
            background: linear-gradient(90deg, #fffbe6 0%, #ffffff 100%);
        }

        &.error {
            border-left: 4px solid #ff4d4f;
            background: linear-gradient(90deg, #fff2f0 0%, #ffffff 100%);
        }

        .alert-content {
            display: flex;
            align-items: center;
            flex: 1;

            span {
                font-size: 14px;
                color: #333;
                word-break: break-word;
            }
        }

        .alert-close {
            font-size: 20px;
            color: #999;
            cursor: pointer;
            margin-left: 20px;
            flex-shrink: 0;
            transition: color 0.3s;

            &:hover {
                color: #666;
            }
        }
    }

    @keyframes slideIn {
        from {
            transform: translateX(100%);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }

    @keyframes pulse {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.7;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes badgePulse {
        0% {
            box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.7);
        }
        70% {
            box-shadow: 0 0 0 6px rgba(255, 77, 79, 0);
        }
        100% {
            box-shadow: 0 0 0 0 rgba(255, 77, 79, 0);
        }
    }
}
</style>
